import { render, staticRenderFns } from "./H5Office.vue?vue&type=template&id=6ba95a38"
import script from "./H5Office.vue?vue&type=script&lang=js"
export * from "./H5Office.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports